import { EnrollmentCenterGenderDistribution } from '../../../lib/types/models/center/center-distributions'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterGenderDistribution(id: number, journeyId?: number) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getGenderDistribution.url, { id }), {
        journeyId
      })
    )
    .get<EnrollmentCenterGenderDistribution>()
}
